import React from "react"
import { Col, Dropdown, Row } from "react-bootstrap"
import { ChevronDown, ChevronUp } from "react-bootstrap-icons"
import BootstrapTable, { ColumnDescription } from "react-bootstrap-table-next"
import filterFactory from "react-bootstrap-table2-filter"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"
// import BootstrapTable from "react-bootstrap-table-next";
import { useTranslation } from "react-i18next"
import { GroupModel } from "../../api/group.api"
import { useAppDispatch } from "../../app/hooks"
import { SearchBar } from "../../components/Tables/Columns"
import CustomTotal from "../../components/Tables/CustomTotal"
import pageListRenderer from "../../components/Tables/PageListRenderer"
import sizePerPageOptionRenderer from "../../components/Tables/SizePerPageOptionRenderer"
import { deleteGroup } from "../../store/group.store"

function GroupsTable({
    groups,
    groupDetails,
    setGroupDetails,
    setShow
}: {
    groups: GroupModel[]
    groupDetails: Record<string, any>
    setGroupDetails: Function
    setShow: Function
}) {
    const { t } = useTranslation()

    const dispatch = useAppDispatch()

    const groupsColumns = [
        {
            dataField: "id",
            text: t("#")
        },
        {
            text: t("Group_Id"),
            dataField: "id"
        },
        {
            text: t("Name"),
            dataField: "name"
        },
        {
            text: t("Description"),
            dataField: "desc"
        },
        {
            text: t("Status"),
            dataField: "ParcelHubUserGroup",
            formatter: (cell: Record<string, any>[]) => {
                return cell.length > 0 ? (
                    <span className="status">{t("Active")}</span>
                ) : (
                    <span className="expired"> {t("Inactive")} </span>
                )
            },
            csvFormatter: (cell: Record<string, any>[], row: Record<string, any>[]) => {
                return cell.length > 0 ? t("Active") : t("Inactive")
            }
        },
        {
            dataField: "",
            text: t("Actions"),
            formatter: (cell: number, row: Record<string, any>) => {
                return (
                    <Dropdown className="actions-menu">
                        <Dropdown.Toggle variant="primary" id="dropdown-basic" size={"sm"} className="py-0">
                            {t("Actions")}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => {
                                    setGroupDetails({
                                        ...row,
                                        menus: row.GroupMenu?.filter(
                                            (gm: Record<string, any>) => !gm.Menu["is_mobile_menu"]
                                        )?.map((gm: Record<string, any>) => gm.Menu["id"]),
                                        mobileMenus: row.GroupMenu?.filter(
                                            (gm: Record<string, any>) => gm.Menu["is_mobile_menu"]
                                        )?.map((gm: Record<string, any>) => gm.Menu["id"])
                                    })
                                    setShow(true)
                                }}
                                className="py-0">
                                {t("Edit")}
                            </Dropdown.Item>
                            {row?.ParcelHubUserGroup?.length === 0 && (
                                <Dropdown.Item
                                    className="py-0"
                                    key={"Delete"}
                                    onClick={() => dispatch(deleteGroup(row?.id))}>
                                    {t("Delete")}
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                )
            }
        }
    ]

    const expandRow = {
        renderer: (row: any): JSX.Element => {
            return <Row className="expanding-row px-4 py-4"></Row>
        },
        showExpandColumn: true,
        expandByColumnOnly: true,
        expandHeaderColumnRenderer: ({ isAnyExpands }: { isAnyExpands: boolean }) => {
            return <></>
        },
        expandColumnRenderer: ({ expanded }: { expanded: boolean }) => {
            if (expanded) {
                return <ChevronUp color="#2D3748" size={10} className="mx-2 my-3 arrow-icon" />
            }
            return <ChevronDown color="#2D3748" size={10} className="mx-2 my-3 arrow-icon" />
        }
    }

    const options = {
        sizePerPage: 50,
        hideSizePerPage: false,
        hidePageListOnlyOnePage: true,
        sizePerPageOptionRenderer,
        showTotal: true,
        pageListRenderer,
        paginationTotalRenderer: CustomTotal
    }

    const { ExportCSVButton } = CSVExport

    return (
        <div className="table-responsive">
            {groupsColumns && (
                <ToolkitProvider
                    keyField="id"
                    data={groups}
                    columns={groupsColumns as ColumnDescription<any, any>[]}
                    search={{ searchFormatted: true }}
                    exportCSV={{
                        fileName: "GroupsTable.csv",
                        noAutoBOM: false,
                        exportAll: false,
                        onlyExportFiltered: true
                    }}>
                    {(props) => (
                        <div className="table-container my-4">
                            <Row className="search groups-search">
                                <Col xs={12} sm={12} md={12} lg={12} className="d-flex justify-content-end">
                                    <SearchBar {...props.searchProps} />
                                </Col>
                                <Col className="d-none">
                                    {/* <ExportCSVButton {...props.csvProps} id="groupsExportButton">
                        Export
                    </ExportCSVButton> */}
                                </Col>
                            </Row>
                            <Row className="table-data my-3">
                                <Col>
                                    <BootstrapTable
                                        expandRow={expandRow}
                                        {...props.baseProps}
                                        wrapperClasses="table-wrapper my-3 "
                                        headerClasses="header-class"
                                        bordered={false}
                                        noDataIndication={t("No_Record")}
                                        filter={filterFactory()}
                                        rowClasses="custom-table-row"
                                        condensed={true}
                                        pagination={paginationFactory(options)}
                                        sort={{ dataField: "email_verified_at", order: "desc" }}
                                    />
                                </Col>
                            </Row>
                        </div>
                    )}
                </ToolkitProvider>
            )}
        </div>
    )
}

export default GroupsTable
